export default __webpack_public_path__ + "static/media/background.692347a3.png";